<template>
  <div class="bloc-activity">
    <v-row
      v-if="isActive || isEdition"
      jusitfy="center"
      class="bloc"
    >
      <v-col
        cols="2"
        class="bloc-element name"
      >
        <p>{{ activity.name[lang] }}</p>
      </v-col>

      <v-col
        class="bloc-element frequency"
      >
        <VSelect
          v-model="data.activity.frequency.id"
          required
          extraClass="hide-label"
          :disabled="!isEdition"
          :items="getFrequencyByLang"
        />
      </v-col>

      <v-col
        class="bloc-element"
      >
        {{ activity.procedure ? activity.procedure.name[lang] : '.' }}
      </v-col>

      <v-col
        cols="6"
        class="bloc-element"
      >
        <v-row class="bloc-calendar">
          <v-icon
            :class="{notDisabled: isEdition} "
            @click="toggleAll"
          >
            {{ allIsCheck() ? "mdi-checkbox-multiple-outline" : " mdi-checkbox-multiple-blank-outline" }}
          </v-icon>

          <div class="select-check">
            <v-checkbox
              v-for="(month, index) in months"
              :key="index"
              v-model="data.activity.months"
              :disabled="!isEdition"
              class="month-square"
              :value="index + 1"
            >
              <template v-slot:label>
                <span class="label">{{ month }}</span>
              </template>
            </v-checkbox>
          </div>
          <v-btn
            v-if="isEdition"
            fab
            xSmall
            class="transform-close-btn"
            color="secondary"
            @click="onClickToggle"
          >
            <v-icon>
              {{ data.activity.active ? 'mdi-close' : 'mdi-eye' }}
            </v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        VSelect,
    },
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
        frequencies: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            data: {
                activity: null,
                frequencies: [],
            },
            language: this.lang,
        };
    },
    computed: {
        ...mapGetters([
            'lang',
            'teamMainLang',
        ]),
        months() {
            return ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
        },
        isActive() {
            return this.data.activity.active;
        },
        getFrequencyByLang() {
            return this.frequencies.map(frequency => ({
                ...frequency,
                name: frequency.name[this.lang] || frequency.name[this.teamMainLang],
            }));
        },
    },
    watch: {
        activity: {
            handler() {
                this.data.activity = this.activity;
                if (!this.activity.frequency) {
                    this.data.activity.frequency = { id: null };
                }
            },
            immediate: true,
        },
        data: {
            handler() {
                this.$emit('updateData', this.data.activity);
            },
            deep: true,
        },
    },
    methods: {
        onClickToggle() {
            this.data.activity.active = !this.data.activity.active;
        },
        allIsCheck() {
            return this.data.activity.months.length === this.months.length;
        },
        toggleAll() {
            if (this.isEdition) {
                // Very important. This is for reactivity never change it
                this.data = {
                    ...this.data,
                    activity: {
                        ...this.data.activity,
                        months: this.allIsCheck() ? [] : [...Array(this.months.length).keys()].map(k => k + 1),
                    },
                };
            }
        },
    },
};
</script>
<style scoped lang="scss">

    .bloc {
      display: flex;
      flex-direction: row;
      align-items: center
    }

  @media screen and (max-width: 960px) {
    .bloc-calendar {
      width: 310px;
      margin-top: 15px;
    }
    .bloc-activity {
      min-width: 500px;
    }
    .bloc-element {
      min-width: 200px;
      max-width: 500px;

      p {
        white-space: nowrap;
      }
    }
    .name {
      overflow-x: hidden;
      p {
        max-width: 500px;
        text-overflow: ellipsis;
        margin: 0
      }
    }
    .frequency {
      max-width: 300px;
    }

    .bloc {
      display: flex ;
      flex-direction: column;
      align-items: flex-start;
      min-width: 500px;
      width: max-content;
      margin-top: 10px
    }
  }

</style>
